$(".submit-js").click(function(event){       
  event.preventDefault();
  var ckb_status = $("#confirm_sub").prop('checked'); 
  var $email = $(this).parents('.form_mailchamp').find('#mce-EMAIL').val();
  isEmail();
  isCheckbox();
  function isEmail(){
  if ($email.length < 1) {
      $("#email-required").show();
      $("#email-invalid").hide();
      return false;
    } else {
      $("#email-required").hide();
      var regEx = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      var validEmail = regEx.test($email);
      if (!validEmail) {
        $("#email-invalid").show();
        return false;
      }else {
        $("#email-invalid").hide();
        return true;
      }
    }
  }
  function isCheckbox() {
    if(!ckb_status){
      $("#checkbox-error").show();
      return false;
    }else{
      $("#checkbox-error").hide();
      return true;
    }
  }
  if(isEmail() && isCheckbox()){
    $(".form_mailchamp").submit();
  }
});


// $(".form_mailchamp").submit(function( event ) {
//   event.preventDefault();
//   var ckb_status = $("#confirm_sub").prop('checked'); 
//   var email = $(this).find("#mce-EMAIL").val();
  
//   function validation(){
//   if (email.length < 1) {
//       $(this).find("#email-required").show();
//       $(this).find("#email-invalid").hide();
//     } else {
//       $(this).find("#email-required").hide();
//       var regEx = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;;
//       var validEmail = regEx.test(email);
//       if (!validEmail) {
//         $(this).find("#email-invalid").show();
//         return false;
//       }else {
//         $(this).find("#email-invalid").hide();
//         return true;
//       }
//     }
//     if(!ckb_status){
//       $(this).find("#checkbox-error").show();
//       return false;
//     }else{
//       $(this).find("#checkbox-error").hide();
//       return true;
//     }
//   }
  
//   if (validation()) {
//        $(".form_mailchamp").submit();
//     }
// });
$('.featured-cardss .carousels').slick({
  dots: true,
  arrows:false,
  infinite: true,
  autoplay:true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1
});